import Vuex from 'vuex'
import Vue from 'vue'
Vue.use(Vuex)
import * as api from '@/utlis/api';
const store = new Vuex.Store({
  state:{
	token:'',
	goodsCount:0,//购物车数量
    activeIndex:0,//导航路由二级
	className:"",//导航路由二级
	classifyList:[],//所有一级分类
	user:{},
	isChecked:false,
  },
  mutations:{
	setuser2(state,data){
		let user = state.user;
		for(let i in user){
			if(typeof(data[i])=='string')
				data[i] = data[i].trim();
			if(data[i])
				user[i] = data[i];
		}
		state.user = user;
	},
	setisChecked(state,data){
		state.isChecked = data;
	},
	setuser(state,data){
		state.user = data;
	},
	setclassName(state,data){
		state.className = data;
	},
	setactiveIndex(state,data){
		state.activeIndex = data;
	},
	settoken(state,data){
		localStorage.setItem('token',data);
		state.token = data;
	},
	setclassifyList(state,data){
		state.classifyList = data;
	},
	setgoodsCount(state,data){
		state.goodsCount = data;
	}
  },
  actions:{
	async setgoodsCount(context){//获取购物车数量
		if(!context.state.token)return;
		let {data} = await api.default.PostGoodscount();
		if(typeof data === 'number')
			context.state.goodsCount = data;
	},
	async getUser(context){
		if(!context.state.token)return;
			let {data,code} = await api.default.PostuserInfo();
			if(code==200){
				if(!data.avatar)data.avatar = require('@/assets/images/timg.jpg')
				context.state.user = data;
				// console.log("用户数据更新啦",data);
			}
	}
  }
})
//
export default store